import { z } from 'zod'

import { SubmitSponsorship } from '../../../services/events'
import { Activity } from '../../../types'

import i18n from '../../../i18n'

export const SubmitSponsorshipSchema = z.object({
  type: z.number(),
  activity: z.nativeEnum(Activity),
  terms_accepted: z.literal(true, {
    errorMap: () => ({
      message: i18n.t('Vous devez accepter les conditions générales', { ns: 'common' }),
    }),
  }),
  request_registration_costs: z.boolean().default(false),
  request_accommodation_costs: z.boolean().default(false),
  request_travel_costs: z.boolean().default(false),
}) satisfies z.ZodType<SubmitSponsorship['data'], z.ZodTypeDef, unknown>
export type SubmitSponsorshipSchema = z.infer<typeof SubmitSponsorshipSchema>
